import {Text, Tooltip} from "@chakra-ui/react";
import {useRef, useState, useEffect} from "react";
export function TruncatedTextWithTooltip({children, ...props}) {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        setIsTruncated(
          textRef.current.scrollWidth > textRef.current.clientWidth
        );
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);

    return () => {
      window.removeEventListener("resize", checkTruncation);
    };
  }, [children]);

  return (
    <Tooltip label={children} isDisabled={!isTruncated}>
      <Text ref={textRef} isTruncated {...props}>
        {children}
      </Text>
    </Tooltip>
  );
}
